module.exports = __webpack_public_path__ + "img/diskbg.383fdbac.png";